import { SetIfc } from '../SetIfc';
import { SetListenerIfc } from '../SetListenerIfc';
import { BitBoardIdManager32 } from '../id/manager32/BitBoardIdManager32';
import { IdManagerIfc } from '../id/IdManagerIfc';
import { RecShapeIfc } from '../../shape/RecShapeIfc';

export class AbstractContainer implements SetIfc{
    idMgr:IdManagerIfc;
		
    metaData:Map<string, string>;
    
    public isSet():boolean{
        return true;
    }

    constructor()
    {
        this.idMgr = new BitBoardIdManager32();
        this.metaData = new Map<string, string>();
    }
    
    public addMeta(name:string, value:string):void
    {
        this.metaData.set(name, value );
    }
    
    public removeMetas(metas:Array<string>):void
    {
        for (var meta of metas)
        {
            this.metaData.delete( meta );
        }
    }
    
    public removeMeta(name:string):void
    {
        this.metaData.delete( name );
    }
    
    public getMeta(name:string):string
    {
        return this.metaData.get( name );
    }
    
    public addMetas(names:Array<string>, values:Array<string>):void
    {
        for (let i:number = 0; i < names.length; i++)
        {
            this.addMeta(names[i], values[i]);
        }
    }
    
    public destruct():void
    {
        this.idMgr = null;
    }
    
    public getSize():number
    {
        return this.idMgr.size();
    }
    
    public assertContains(id:number):void
    {
        if (!this.contains(id))
        {
            throw new Error("Record not exists in set: " + id);
        }
    }
    
    public contains(id:number):Boolean
    {
        return this.idMgr.isAllocated(id);
    }
    
    public put(id:number):void
    {
        if (this.idMgr.isAllocated(id))
        {
            throw new Error("Attempt to add duplicate record with id: " + id);
        }
        this.idMgr.allocateConcrete(id);
    }
    
    public removeRecord(id:number):void
    {
        if (!this.idMgr.isAllocated(id))
        {
            throw new Error("Attempt to remove not existing record: " + id);
        }
        this.idMgr.free(id);
    }
    
    public reset():void
    {
        this.idMgr.reset();
    }
    
    public getShape():RecShapeIfc
    {
        throw new Error("Shouldn't be called");
    }
    
    public addListener(listener:SetListenerIfc):void
    {
        throw new Error("Shouldn't be called");
    }
    
    public removeListener(listener:SetListenerIfc):void
    {
        throw new Error("Shouldn't be called");
    }

}